export default __webpack_public_path__ + "static/media/customers.b5fe6bc2.svg";